import { render, staticRenderFns } from "./LaunchingQueuePageSubdomainLocalesModal.vue?vue&type=template&id=5d7d5c7e&"
import script from "./LaunchingQueuePageSubdomainLocalesModal.vue?vue&type=script&lang=js&"
export * from "./LaunchingQueuePageSubdomainLocalesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports